export default "__VITE_ASSET__DzjogF8B__"